const signupsActions = {
  SET_ADDITIONAL_INFO: "SET_ADDITIONAL_INFO",
  /** Sets the boolean value in the "Additional Info" tab for the "Ask for more information?" checkbox */
  setAdditionalInfo: (additionalInfo) => ({
    type: signupsActions.SET_ADDITIONAL_INFO,
    additionalInfo,
  }),
  SET_CURRENT_SIGNUP_LIST: "Set Current Signup List",
  /** Sets the signup currently being viewed by the user. */
  setCurrentSignupList: (signupList) => ({
    type: signupsActions.SET_CURRENT_SIGNUP_LIST,
    signupList,
  }),
};

export default signupsActions;
